// extracted by mini-css-extract-plugin
export default {"profilePage":"profile_profilePage__tmfGG","wrapper":"profile_wrapper__a+aAM","textInput":"profile_textInput__t5vhA","input":"profile_input__QOkoO","label":"profile_label__7ZowZ"};